module.exports = __webpack_public_path__ + "static/media/KCC_Membership_Application_Form_2023.69a6d370.docx";